export default "__VITE_ASSET__5b970893__"